/*** Imports ***/

/* Style imports */
import './styles.css';

/* Library imports */
import React from "react";
import PropTypes from 'prop-types';
import Constants from "../../../../../constants/Constants";
import Gutter from "../../../../Gutter/Gutter";
import TitleLogo from "../../../../TitleLogo/TitileLogo";
import SubSection from "../../GetDataBaseView/Component/SubSection/SubSection";
import Section from "../../GetDataBaseView/Component/Section/Section";
import BtnSolid from "../../../../Buttons/BtnSolid/BtnSolid";
import Content from "../../../../../content/Content";


/*** End Imports ***/



const GetBoostJobView = (props) => {

    // helper function
    // event handlers for static component
    const {
        rate, 
    } = props;

    
    
    return (
        <div className="boost-job-view">
            <div className="content-view">
                <div className="content-view-left">

                    <Gutter height={48}/>

                    <div className="cv-left-1">
                        <p>{Content.BOOST_A_JOB_INFO_POPUP.HEADER}</p>
                    </div>

                    <Gutter height={34}/>

                    <div className="cv-left-2">
                        <div className="cvl2-left">
                            <Gutter height={19.5}/>
                            <TitleLogo
                                titleHeader={Content.BOOST_A_JOB_INFO_POPUP.LEFT_SUB_HEADER}
                                srcIcon={Constants.ICONS.BOOST_JOB_BLUE}
                                isActive
                                horizontal
                                imageStyle={{
                                    maxHeight: '24px',
                                    maxWidth: '15px'
                                }}
                            />

                            <Gutter height={31.5}/>

                            <div className="cvl2-section">
                                <Section>{Content.BOOST_A_JOB_INFO_POPUP.COINS_SECTION_1}</Section>
                            </div>

                            <Gutter height={10}/>

                            <div className="cvl2-sub-section">
                                <SubSection>{Content.BOOST_A_JOB_INFO_POPUP.COINS_SUB_SECTION_1}</SubSection>
                            </div>

                            <Gutter height={30}/>

                            <div className="cvl2-section">
                                <Section>{Content.BOOST_A_JOB_INFO_POPUP.COINS_SECTION_2}</Section>
                            </div>

                            <Gutter height={10}/>

                            <div className="cvl2-sub-section">
                                <SubSection>{Content.BOOST_A_JOB_INFO_POPUP.COINS_SUB_SECTION_2}</SubSection>
                            </div>
                        </div>

                        {/*Right Flex*/}

                        <div className="cvl2-right">

                            <Gutter height={19.5}/>

                            <TitleLogo
                                titleHeader={Content.BOOST_A_JOB_INFO_POPUP.RIGHT_SUB_HEADER}
                                srcIcon={Constants.ICONS.PEOPLE_BLUE}
                                isActive
                                horizontal
                                imageStyle={{
                                    maxHeight: '24px',
                                    maxWidth: '29px'
                                }}
                            />

                            <Gutter height={31.5}/>

                            <div className="cvl2-section">
                                <Section>{Content.BOOST_A_JOB_INFO_POPUP.BOOST_SECTION_1}</Section>
                            </div>

                            <Gutter height={10}/>

                            <div className="cvl2-sub-section">
                                <SubSection>{Content.BOOST_A_JOB_INFO_POPUP.BOOST_SUB_SECTION_1}</SubSection>
                            </div>

                            <Gutter height={30}/>

                            <div className="cvl2-section">
                                <Section>{Content.BOOST_A_JOB_INFO_POPUP.BOOST_SECTION_2}</Section>
                            </div>

                            <Gutter height={10}/>

                            <div className="cvl2-sub-section">
                                <SubSection>{Content.BOOST_A_JOB_INFO_POPUP.BOOST_SUB_SECTION_2}</SubSection>
                            </div>

                        </div>

                    </div>

                    <div className="cvlb-no-profile">
                        <div className="cvlb-no-profile-round-wrapper">
                            <div className="cvlb-no-profile-rounded">1</div> = Rs. {rate}
                        </div>
                    </div>

                </div>

                <Gutter width={17}/>
            </div>

        </div>
    );
};

/**
 * all prop types which can be passed to this component
 */
GetBoostJobView.propTypes = {

};

/**
 * Only if default initialization is required
 * Default props value for this component
 */
GetBoostJobView.defaultProps ={

};

export default GetBoostJobView;


// WEBPACK FOOTER //
// ./src/components/GetMoreProfilesModal/Components/GetBoostJob/GetBoostJobView/GetBoostJobView.js